import SearchFlights from "../features/searchFlights/SearchFlights";
import MapboxMapWrapper from "../mapbox/MapboxMapWrapper";
import React from "react";
import HeaderLogo from "./HeaderLogo";
import OAGPromoLogo from "./OAGPromoLogo";
import OAGCopyright from "./OAGCopyright";

function MOB12() {
  return (
    <div className="container">
      <HeaderLogo />
      <SearchFlights layout="horizontal" />
      <OAGPromoLogo />
      <div id="mapbox-wrapper">
        <MapboxMapWrapper />
      </div>
      <OAGCopyright />
    </div>
  );
}

export default MOB12;
